/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChineseWaybillVo } from './ChineseWaybillVo';
import {
    ChineseWaybillVoFromJSON,
    ChineseWaybillVoFromJSONTyped,
    ChineseWaybillVoToJSON,
    ChineseWaybillVoToJSONTyped,
} from './ChineseWaybillVo';

/**
 * 
 * @export
 * @interface ResponseChineseWaybillVo
 */
export interface ResponseChineseWaybillVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseChineseWaybillVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseChineseWaybillVo
     */
    message?: string;
    /**
     * 
     * @type {ChineseWaybillVo}
     * @memberof ResponseChineseWaybillVo
     */
    data?: ChineseWaybillVo;
}

/**
 * Check if a given object implements the ResponseChineseWaybillVo interface.
 */
export function instanceOfResponseChineseWaybillVo(value: object): value is ResponseChineseWaybillVo {
    return true;
}

export function ResponseChineseWaybillVoFromJSON(json: any): ResponseChineseWaybillVo {
    return ResponseChineseWaybillVoFromJSONTyped(json, false);
}

export function ResponseChineseWaybillVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseChineseWaybillVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ChineseWaybillVoFromJSON(json['data']),
    };
}

export function ResponseChineseWaybillVoToJSON(json: any): ResponseChineseWaybillVo {
    return ResponseChineseWaybillVoToJSONTyped(json, false);
}

export function ResponseChineseWaybillVoToJSONTyped(value?: ResponseChineseWaybillVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': ChineseWaybillVoToJSON(value['data']),
    };
}

